import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';

import otherStyles from './otherAdditionalService.module.css';
import commonAddServiceStyles from '../commonAdditionalService/commonAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({

  growField: {
    flexGrow: 1,
    marginRight: '20px'
  }
});

interface OtherAdditionalServiceProps {
  classes: any;
  reason: string;
  total: string;
  additionalInformation: string;
  handleChange: (event: any, propertyName: string) => void;
  error: boolean;
  
};

const otherAdditionalService = (props: OtherAdditionalServiceProps) => {
  return (
    <FormControl fullWidth={ true }>
      <Grid container className={ commonAddServiceStyles.gridContainer }>
        <Grid item md={6} sm={6} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <div className={ commonStyles.inputLabelWrapper } >
            <label className={ commonStyles.inputLabel }> Other Service Reason <span className={ otherStyles.asterisk }>*</span> </label>
            <TextField
              error={ props.error && !props.reason }
              label=""
              value={ props.reason }
              variant="outlined"
              onChange={ (event) => props.handleChange(event, 'otherServiceReason') }
              className={props.classes.growField}
              inputProps={{ classes: { notchedOutline:props.classes.overrideBorder },
                            style: { padding: TEXT_FIELD_PADDINGS }
                          }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </Grid>

        <Grid item md={6} sm={6} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <div className={ commonStyles.inputLabelWrapper } >
            <label className={ commonStyles.inputLabel }> Total Cost <span className={ otherStyles.asterisk }>*</span></label>
            <TextField
              fullWidth={ true }
              error={ props.error && !props.total || isNaN(Number(props.total)) || props.total !== '' && Number(props.total) <= 0 }
              label=""
              value={ props.total }
              variant="outlined"
              onChange={ (event) => props.handleChange(event, 'otherServiceTotal') }
              inputProps={{ classes: { notchedOutline:props.classes.overrideBorder },
                            style: { padding: TEXT_FIELD_PADDINGS }
                          }} 
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </Grid>
      
        <Grid item md={12} sm={12} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <div className= { ` ${ otherStyles.addInfoWrapper } ${ commonStyles.inputLabelWrapper }` }>
            <label className={ commonStyles.inputLabel }>  Additional information to GHA </label>
            <TextField
              fullWidth={ true }
              id="outlined-disabled"
              label=""
              variant="outlined"
              onChange={ (event) => props.handleChange(event, 'additionalInformation') }
              value={ props.additionalInformation }
              inputProps={{ classes: { notchedOutline:props.classes.overrideBorder },
                            style: { padding: TEXT_FIELD_PADDINGS }
                          }}
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </Grid>
      </Grid>
    </FormControl>
  );
}

export default withStyles(styles)(otherAdditionalService);